import { RouteLocationNormalizedLoaded } from 'vue-router';

export function replaceBookmark(bookmark: string, content: string, replaceValue: string): string {
  if (!content) return content;
  const bookMarkToken = `{{${bookmark}}}`;
  return content.replaceAll(bookMarkToken, replaceValue);
}

export function replaceBookmarks<T>(object: T, replaceObject: object): T {
  let raw = JSON.stringify(object);
  for (const [key, value] of Object.entries(replaceObject)) {
    raw = replaceBookmark(key, raw, value);
  }
  return JSON.parse(raw);
}

/**
 * To replace content like query string
 * @param content
 * @param route
 * @returns
 */
export function replaceBookmarksFromRoute(content: string, route: RouteLocationNormalizedLoaded) {
  if (!route.query || !content) return content;
  const keys = Object.keys(route.query);
  keys.forEach((key) => {
    content = replaceBookmark(key, content, route.query[key] as string);
  });
  return content;
}
